<template>
    <div>
        <a-form-model layout="inline" :model="searchForm">
            <a-form-model-item label="课程名称">
                <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName"
                         placeholder="请输入课程名称"/>
            </a-form-model-item>
            <a-form-model-item label="课时排序">
                <a-input-number :min="0" :max="99999" allowClear class="serach-item"
                                v-model="searchForm.childCourseDisplayOrder"
                                placeholder="请输入课时排序"/>
            </a-form-model-item>
            <a-form-model-item label="课时名称">
                <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.childCourseName"
                         placeholder="请输入课时名称"/>
            </a-form-model-item>
            <a-form-model-item label="课时类型">
                <a-select class="serach-item" allowClear v-model="searchForm.childCourseType"
                          placeholder="请选择课时类型">
                    <a-select-option value="1">测评课时</a-select-option>
                    <a-select-option value="2">训练课时</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="内容排序">
                <a-input-number :min="0" :max="99999" allowClear class="serach-item"
                                v-model="searchForm.contentDisplayOrder" placeholder="请输入内容排序"/>
            </a-form-model-item>
            <a-form-model-item>
                <a-button @click="getPageList(1)" type="primary" html-type="button">
                    查询
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="btn-group" v-if="tableSelectedRowKeys.length">
            <span @click="edit"><a-icon type="edit"/>编辑</span>
            <span @click="swap"><a-icon type="swap"/>替换</span>
            <span @click="checkboxDelete"><a-icon type="delete"/>删除</span>
        </div>
        <!--<a-button-group style="margin-bottom: 15px;">
            <a-button @click="edit" type="primary" ghost icon="edit">编辑</a-button>
            <a-button @click="swap" type="primary" ghost icon="swap">替换</a-button>
            <a-button @click="checkboxDelete" type="danger" ghost icon="delete">删除</a-button>
        </a-button-group>-->

        <a-table style="min-width: 800px;"
                 :columns="columns"
                 :scroll="{y: 300}"
                 rowKey="id"
                 :row-selection="rowSelection"
                 :pagination="tableRelevant.tablePagination"
                 :loading="tableRelevant.tableLoading"
                 :locale="tableRelevant.locale"
                 :dataSource="tableRelevant.tableDataSource">
            <div slot="courseName" slot-scope="text">
                {{ text.courseName }}{{ text.period ? ' - ' + text.period : '' }}
            </div>
            <div slot="abilityTypeName" slot-scope="text">
                <div class="self_td" v-for="item in text.contentAbilitys" :key="item.id">
                    {{ item.abilityTypeName ? item.abilityTypeName + '-' : '' }}
                    {{ item.firstAbilityName ? item.firstAbilityName : '' }}
                    {{ item.secondAbilityName ? '-' + item.secondAbilityName : '' }}
                </div>
            </div>
            <div slot="guideVideo" slot-scope="text">
                <a-switch :checked="text.isLinkVedio" checked-children="启用" un-checked-children="禁用" disabled/>
            </div>
            <div slot="scoreSetting" slot-scope="text" class="table-ability">
                <div v-for="item in text.contentAbilitys">
                    <a-switch :checked="text.contentAbilityIds.includes(item.contentAbilityId)" checked-children="启用" un-checked-children="禁用" disabled/>
                </div>
            </div>
            <div slot="fixedContent" slot-scope="text">
                <a-switch :checked="text.isRegularContent" checked-children="启用" un-checked-children="禁用" disabled/>
            </div>
            <div slot="action" class="action" slot-scope="text">
                <a-popconfirm title="确认删除？" @confirm="del(text)">
                    <a href="javascript:;" class="red">删除</a>
                </a-popconfirm>
            </div>
        </a-table>

        <a-modal :title="contentInfo.contentName + ' / 编辑内容'" v-model="editModal.visible"
                 :confirm-loading="editModal.confirmLoading" :destroyOnClose="true"
                 :cancelText="editModal.cancelText" :okText="editModal.okText" :centered="true" width="80%"
                 @cancel="editModalCancel('modal')"
                 @ok="editModalOk" :cancel-button-props="{ on: { click: editModalCancel } }">
            <div style="padding: 0 30px;">
                <div style="width: 700px;margin: 0 auto;">
                    <a-steps :current="editModal.current" style="margin-bottom: 25px;">
                        <a-step title="设置内容"/>
                        <a-step title="确认内容"/>
                    </a-steps>
                </div>
                <ThirdStep :contentData="editModal.firstStepData" type="edit" v-if="editModal.current === 0"
                           ref="thirdStep"/>
                <FourthStep :contentData="editModal.firstStepData" type="edit" v-if="editModal.current === 1"
                            ref="fourthStep"/>
            </div>
        </a-modal>

        <a-modal :title="contentInfo.contentName + ' / 替换内容'" v-model="swapModal.visible"
                 :confirm-loading="swapModal.confirmLoading" :destroyOnClose="true"
                 :cancelText="swapModal.cancelText" :okText="swapModal.okText" :centered="true" width="80%"
                 @ok="swapModalOk" :cancel-button-props="{ on: { click: swapModalCancel } }"
                 @cancel="swapModalCancel(1)">
            <div style="padding: 0 30px;">
                <a-steps :current="swapModal.current" style="margin-bottom: 25px;">
                    <a-step title="选择新内容"/>
                    <a-step title="设置内容"/>
                    <a-step :title="`确认”${contentInfo.contentName}“`"/>
                </a-steps>
                <FirstStep v-if="swapModal.current === 0" :pageData="swapModal.firstData" :abilityList="abilityList"
                           ref="firstStep"/>
                <ThirdStep v-if="swapModal.current === 1" :contentData="swapModal.secondData" type="edit"
                           ref="thirdStep"/>
                <FourthStep v-if="swapModal.current === 2" :contentData="swapModal.secondData" ref="fourthStep"/>
            </div>
        </a-modal>
    </div>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import FirstStep from "../generalSteps/firstStep";
import ThirdStep from "../generalSteps/thirdStep";
import FourthStep from "../generalSteps/fourthStep";

const columns = [
    {
        title: '关联课程',
        scopedSlots: {customRender: 'courseName'},
    },
    {
        title: '课时排序',
        width: 100,
        dataIndex: 'childCourseDisplayOrder',
    },
    {
        title: '关联课时',
        dataIndex: 'courseSessionName',
    },
    {
        title: '课时类型',
        width: 100,
        dataIndex: 'courseSessionTypeName',
    },
    {
        title: '内容排序',
        width: 100,
        dataIndex: 'contentDisplayOrder',
    },
    {
        title: '能力维度',
        class: 'testClass',
        key: 'abilityTypeName',
        align: 'center',
        scopedSlots: {customRender: 'abilityTypeName'},
    },
    {
        title: '指导视频',
        width: 100,
        scopedSlots: {customRender: 'guideVideo'},
    },
    {
        title: '算分设置',
        width: 100,
        scopedSlots: {customRender: 'scoreSetting'},
    },
    {
        title: '固定内容',
        width: 100,
        scopedSlots: {customRender: 'fixedContent'},
    },
    {
        title: '执行次数',
        width: 100,
        dataIndex: 'executionsNumber',
    },
    {
        title: '操作',
        width: 100,
        scopedSlots: {customRender: 'action'},
    },
];
export default {
    name: "seeContent",
    components: {FirstStep, ThirdStep, FourthStep},
    props: {
        abilityList: {
            type: Array,
            value: [],
        },
        contentInfo: {
            type: Object,
            value: {},
        },
    },
    data() {
        return {
            seriesInfo: this.$store.getters["course/getSeriesInfo"](),
            searchForm: {
                courseName: undefined,
                childCourseDisplayOrder: undefined,
                childCourseName: undefined,
                childCourseType: undefined,
                contentDisplayOrder: undefined,
            },
            columns,
            tableRelevant: tableRelevant.call(this),
            editModal: {
                title: "",
                visible: false,
                confirmLoading: false,
                okText: "下一步",
                cancelText: "取消",
                current: 0,
                firstStepData: [],
            },
            swapModal: {
                visible: false,
                confirmLoading: false,
                okText: "下一步",
                cancelText: "取消",
                current: 0,
                firstData: {
                    tableType: "radio",
                    contentType: 1,
                    selectedKeys: [],
                    selectedRows: [],
                },
                secondData: [],
            },
            tableSelectedRowKeys: [],
            tableSelectedRows: [],
        };
    },
    computed: {
        rowSelection() {
            return {
                selectedRowKeys: this.tableSelectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.tableSelectedRowKeys = selectedRowKeys;
                    this.tableSelectedRows = this.tableSelectedRows.concat(selectedRows);
                    this.tableSelectedRows = this.tableSelectedRowKeys.map(m => {
                        const item = this.tableSelectedRows.filter(f => f.id === m)[0] || {};
                        item.contentName = this.contentInfo.contentName;
                        item.versionName = this.contentInfo.versionName;
                        item.contentType = this.contentInfo.contentType;
                        item.contentTypeName = this.contentInfo.contentTypeName;
                        return item;
                    });
                },
            };
        },
    },
    mounted() {
        this.getPageList(1);
    },
    methods: {
        getPageList(pageIndex) {
            const params = {
                courseSeriesId: this.seriesInfo.id,
                contentId: this.contentInfo.contentId,
                pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                pageSize: this.tableRelevant.tablePagination.pageSize,
                ...this.searchForm,
            };
            if (typeof params.childCourseDisplayOrder !== "number") {
                delete params.childCourseDisplayOrder;
            }
            if (typeof params.contentDisplayOrder !== "number") {
                delete params.contentDisplayOrder;
            }
            this.tableRelevant.tableLoading = true;
            this.$http.CourseResource.contentListSerie(params).then(({ data }) => {
              this.tableRelevant.tableDataSource = data.items;
              this.tableRelevant.tablePagination.total = data.totalCount;
              this.tableRelevant.tablePagination.current = data.pageIndex;
            }).finally(() => {
              this.tableRelevant.tableLoading = false;
            })
        },
        deleteSeriesContent(params) {
            this.tableRelevant.tableLoading = true;
            this.$http.CourseResource.contentDelete(params).then(res => {
                const {data, status, message} = res;
                    this.$message.success(message);
                    if (this.tableRelevant.tableDataSource.length <= 1) {
                        this.$emit("close");
                    } else {
                        this.$emit("close", true);
                        this.getPageList(1);
                    }

            }).finally(() => {
              this.tableRelevant.tableLoading = false;
            })
        },
        del(val) {
            const params = {
              "courseSessionIds": [val.courseSessionId],
              "contentIds": [val.contentId]
            };
            this.deleteSeriesContent(params);
        },
        checkboxDelete() {
            this.$message.destroy();
            if (!this.tableSelectedRows.length) {
                this.$message.warning("请选择内容");
                return;
            }
            this.$confirm({
                centered: true,
                width: 500,
                okType: 'danger',
                okText: '继续删除',
                title: '批量删除内容',
                content: h => h('div', {}, [
                    '此内容将从所有关联课程和关联课时中删除，请谨慎操作',
                    h('p', {style: {color: 'red'}}, '是否继续删除?'),
                ]),
                onOk: () => {
                    const Params = {
                      "courseSessionIds": this.tableSelectedRows.map(m => m.courseSessionId),
                      "courseIds": this.tableSelectedRows.map(m => m.contentId)
                    }
                    this.deleteSeriesContent(Params);
                },
            });
        },
        swap() {
            this.$message.destroy();
            if (!this.tableSelectedRows.length) {
                this.$message.warning("请选择内容");
                return;
            }
            this.swapModal.visible = true;
        },
        edit() {
            this.$message.destroy();
            if (!this.tableSelectedRows.length) {
                this.$message.warning("请选择内容");
                return;
            }
            this.editModal.visible = true;
            this.editModal.firstStepData = [JSON.parse(JSON.stringify(this.tableSelectedRows[0]))];
        },
        editModalOk() {
            if (this.editModal.current === 0) {
                this.editModal.current = 1;
                this.editModal.okText = "提交";
                this.editModal.cancelText = "上一步";
                // this.editModal.firstStepData = this.$refs.thirdStep.$data.tableRelevant.tableDataSource;
                this.editModal.firstStepData = this.tableSelectedRows.map(m => {
                    m.contentDisplayOrder = this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].contentDisplayOrder;
                    m.executionsNumber = m.contentType === 2 ? this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].executionsNumber : 1;
                    m.isLinkVedio = this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].isLinkVedio;
                    m.contentAbilitys = this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].contentAbilitys;
                    m.isRegularContent = this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].isRegularContent;
                    return m;
                });
            } else {
                const data = this.$refs.fourthStep.$data.tableRelevant.tableDataSource;
                this.editModal.firstStepData = data;
                const Params = {
                  "items": data.map(m => ({
                    // "id": m.id,
                    "courseSessionId": m.courseSessionId,
                    "contentId": m.contentId,
                    "executionsNumber": m.executionsNumber,
                    "isRegularContent": m.isRegularContent,
                    "isLinkVedio": m.isLinkVedio,
                    "displayOrder": m.contentDisplayOrder,
                    "contentAbilityIds": m.contentAbilitys.filter(f => f.isSetting).map(m1 => m1.contentAbilityId),
                  }))
                }
                this.editModal.confirmLoading = true;
                this.$http.CourseResource.contentUpdate(Params).then(res => {
                  this.$message.success(res.message);
                  this.editModalCancel('modal');
                  this.$emit('close');
                }).finally(() => {
                  this.editModal.confirmLoading = false;
                })
            }
        },
        editModalCancel(type) {
            if (type === 'modal') {
                this.editModal.visible = false;
                this.editModal.current = 0;
                this.editModal.okText = "下一步";
                this.editModal.cancelText = "取消";
                this.editModal.firstStepData = [];
                this.tableSelectedRowKeys = [];
                this.tableSelectedRows = [];
                this.getPageList(1);
                return;
            }
            if (this.editModal.current === 1) {
                this.editModal.current = 0;
                this.editModal.okText = "下一步";
                this.editModal.cancelText = "取消";
                this.editModal.firstStepData = [this.editModal.firstStepData[0]];
            } else {
                this.editModal.visible = false;
                this.editModal.firstStepData = [];
            }
        },
        swapModalOk() {
            this.$message.destroy();
            switch (this.swapModal.current) {
                case 0:
                    if (!this.$refs.firstStep.$data.tableSelectedRowKeys.length) {
                        this.$message.error("请选择新内容");
                        return;
                    }
                    this.swapModal.okText = "下一步";
                    this.swapModal.cancelText = "上一步";
                    this.swapModal.firstData.contentType = this.$refs.firstStep.$data.searchForm.contentType;
                    this.swapModal.firstData.selectedKeys = this.$refs.firstStep.$data.tableSelectedRowKeys;
                    this.swapModal.firstData.selectedRows = this.$refs.firstStep.$data.tableSelectedRows;
                    this.swapModal.secondData = [this.tableSelectedRows.map(m => {
                        const item = this.swapModal.firstData.selectedRows[0];
                        m.contentName = item.name;
                        m.versionName = item.versionName;
                        m.contentType = item.contentType;
                        m.contentTypeName = item.contentTypeName;
                        m.contentAbilitys = item.contentAbilitys;
                        m.newContentId = item.id;
                        return m;
                    }).filter(f => !(f.childCourseType === 1 && f.contentType === 2))[0]];
                    this.swapModal.current = 1;
                    break;
                case 1:
                    // this.swapModal.secondData = this.$refs.thirdStep.$data.tableRelevant.tableDataSource;
                    this.swapModal.secondData = this.tableSelectedRows.map(m => {
                        const item = this.swapModal.firstData.selectedRows[0];
                        m.contentName = item.name;
                        m.versionName = item.versionName;
                        m.contentType = item.contentType;
                        m.contentTypeName = item.contentTypeName;
                        m.newContentId = item.id;
                        m.contentDisplayOrder = this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].contentDisplayOrder;
                        m.executionsNumber = item.contentType === 2 ? this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].executionsNumber : 1;
                        m.isLinkVedio = this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].isLinkVedio;
                        m.contentAbilitys = this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].contentAbilitys;
                        m.isRegularContent = this.$refs.thirdStep.$data.tableRelevant.tableDataSource[0].isRegularContent;
                        return m;
                    }).filter(f => !(f.childCourseType === 1 && f.contentType === 2));
                    this.swapModal.okText = "提交";
                    this.swapModal.current = 2;
                    break;
                case 2:
                    this.swapModal.secondData = this.$refs.fourthStep.$data.tableRelevant.tableDataSource;
                    const params = {
                      "items": this.swapModal.secondData.map(m => {
                        return {
                          "courseSessionId": m.courseSessionId,
                          "contentId": m.contentId,
                          "newContentId": m.newContentId,
                          "executionsNumber": m.executionsNumber,
                          "displayOrder": m.contentDisplayOrder,
                          "isLinkVedio": m.isLinkVedio,
                          "isRegularContent": m.isRegularContent,
                          "contentAbilityIds": m.contentAbilitys.filter(f => f.isSetting).map(m1 => m1.id)
                        }
                      })
                    };
                    this.swapModal.confirmLoading = true;
                    this.$http.CourseResource.contentReplace(params).then(res => {
                      this.$message.success(res.message);
                      this.swapModal.visible = false;
                      this.$emit('close');
                    }).finally(() => {
                      this.swapModal.confirmLoading = false;
                    })
                    break;
            }
        },
        swapModalCancel(type) {
            console.log(111);
            if (type === 1) {
                this.swapModal.cancelText = "取消";
                this.swapModal.firstData.contentType = 1;
                this.swapModal.firstData.selectedKeys = [];
                this.swapModal.current = 0;
                return;
            }
            switch (this.swapModal.current) {
                case 1:
                    this.swapModal.cancelText = "取消";
                    this.swapModal.current = 0;
                    break;
                case 2:
                    this.swapModal.okText = "下一步";
                    this.swapModal.cancelText = "上一步";
                    this.swapModal.current = 1;
                    this.swapModal.secondData = [this.swapModal.secondData[0]];
                    break;
                default:
                    this.swapModal.visible = false;
                    this.swapModal.firstData.contentType = 1;
                    this.swapModal.firstData.selectedKeys = [];
            }
        },
    },
};
</script>

<style scoped lang="less">
.table-ability div:not(:last-child) {
    padding-bottom: 32px;
}

.btn-group {
    display: flex;
    background: #f3f9fe;
    height: 40px;
    width: 300px;
    align-items: center;
    border-radius: 40px;
    margin: 15px 0;

    span {
        width: 33%;
        display: block;
        text-align: center;
        height: 18px;
        color: #4495e7;
        cursor: pointer;
    }

    span:not(:last-child) {
        border-right: 1px solid #4495e7;
    }

    span:last-child {
        color: #ff0000;
    }

    i {
        margin-right: 3px;
    }
}

/deep/ .ant-table-tbody .testClass {
    padding: 0 !important;
}

.self_td {
    height: 54px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    justify-content: center;
}
</style>
